import { useTheme } from '@chakra-ui/react';
import React from 'react';
import ButtonMore from '../../buttonMore/buttonMore';
import assets2gestar from '../../../innerAsstes/imagenes hero y modulo curso/imgInfoGestar.png';
import { useAppContext } from '../../../App';

export default function SlideGeneralInfo() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  return (
    <div style={style.textAndImgContainer} className="sansation-bold">
      <div style={style.textContainer}>
        <p style={{ ...style.whiteText, ...style.fontSizeStyle }}>
          SOMOS UN CENTRO DE FORMACIÓN
          <p style={{ ...style.blueText, ...style.fontSizeStyle }}>
            CON MÁS DE 18 AÑOS DE TRAYECTORIA, INNOVACIÓN Y TRANSFOMACIÓN
          </p>
          EN ARGENTINA Y LATAM
        </p>
        <ButtonMore customStyles={style.buttonStyles} redirectTo='sobre-nosotros'/>
      </div>
      <div style={style.imageContainer}>
        <img style={style.image} src={assets2gestar} alt="" />
      </div>
    </div>
  );
}

const styles = (theme, isMobile) => ({
    textAndImgContainer: {
      display: "flex",
      padding: '2vh',
      flexDirection: isMobile? "column-reverse":"row",
      width: '100%',
    },
    textContainer: {
      lineHeight: 1.2,
      display: "flex",
      flexDirection: "column",
      width: isMobile? '100%': '70vw',
      marginBottom: isMobile? '1rem': '0'
    },
    imageContainer:{
     width: isMobile ? '80vw' : '100%',      // Aumenta el ancho en móvil
      height: isMobile ? '80vw' : '100%',     // Aumenta el alto en móvil
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    image:{
      maxWidth: isMobile ? '90vw' : '100%',   // Permite que la imagen crezca más en móvil
      maxHeight: isMobile ? '80vw' : '100%',
      width: isMobile ? '100%' : 'auto',
      height: isMobile ? 'auto' : '30vw',
      display: 'block',
      margin: '0 auto',
      objectFit: 'contain',
    },
    whiteText:{
      color: theme.color.text.primary
    },
    blueText:{
      width: isMobile?'100%':'90%',
      color: theme.color.text.secondary
    },
    fontSizeStyle:{
      fontSize: isMobile? '1rem':'2rem'
    },
    buttonStyles:{
      container:{
        width: isMobile? '60%':'40%',
        height: '10vh',
        padding: '0.5rem',
        marginTop: isMobile? '1rem':'2rem',
        justifyContent: 'space-around',
      },
      text:{
        fontSize: isMobile? '1rem':'1.5rem',
        width: 'auto',
      },
      arrowSvg:{
        width:'20%',
        height:'100%',
      }
    }
  });
